import script from "./FamilyFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./FamilyFilter.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__